import React, { useState, useEffect } from 'react';
import { Multiselect } from '@cloudscape-design/components';
import { getProgramCodes, getProgramConfig } from '../programs/registry';

const STORAGE_KEY = 'chronos_program_scope';

function loadSavedScope(availablePrograms) {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      const valid = parsed.filter(code => availablePrograms.includes(code));
      if (valid.length > 0) return valid;
    }
  } catch { /* ignore */ }
  return availablePrograms;
}

function saveScope(codes) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(codes));
  } catch { /* ignore quota errors */ }
}

const ProgramScopeSelector = ({ availablePrograms, onChange }) => {
  const programs = availablePrograms && availablePrograms.length > 0
    ? availablePrograms
    : getProgramCodes();

  const [selectedCodes, setSelectedCodes] = useState(() => loadSavedScope(programs));

  useEffect(() => {
    if (onChange) {
      onChange(selectedCodes);
    }
  }, [selectedCodes]); // eslint-disable-line react-hooks/exhaustive-deps

  const options = programs.map(code => {
    const config = getProgramConfig(code);
    return {
      value: code,
      label: config ? config.shortName : code,
      description: config ? config.displayName : code,
    };
  });

  const selectedOptions = options.filter(opt => selectedCodes.includes(opt.value));

  const handleChange = ({ detail }) => {
    const codes = detail.selectedOptions.map(opt => opt.value);
    const next = codes.length > 0 ? codes : programs;
    setSelectedCodes(next);
    saveScope(next);
  };

  if (programs.length <= 1) return null;

  return (
    <Multiselect
      selectedOptions={selectedOptions}
      onChange={handleChange}
      options={options}
      placeholder="Programs"
      tokenLimit={2}
      hideTokens={false}
    />
  );
};

export default ProgramScopeSelector;
